import { css } from 'styled-components'

export function mobileCSS(cssInstance) {
  return css`
    @media screen and (max-width: 500px) {
      ${cssInstance}
    }
  `
}
